import React, { useState } from "react";
import CategoryTable from "../../components/Product/CategoryTable";


const dummyData = Array.from({ length: 10 }, (_, i) => ({
 name: `Category is ${i + 1}`,
 status: `Enabled`,
}));

const ITEMS_PER_PAGE = 10;

const Category = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;

  return (
    <div className="flex flex-col w-full gap-4">
  {/* Header */}
  <div className="bg-gray-700 p-3 w-full flex justify-between items-center">
    <h1 className="font-bold text-[1.3rem]">Manage Product Categories</h1>
    <button className="p-2 bg-green-500 rounded-lg">
           Add Category
    </button>
  </div>

  {/* Content */}
  <div className="p-2 w-full bg-gray-700">
    <CategoryTable
      data={dummyData.slice(startIndex, endIndex)}
      currentPage={currentPage}
      totalPages={Math.ceil(dummyData.length / ITEMS_PER_PAGE)}
      onPageChange={handlePageChange}
    />
  </div>
</div>

  );
};

export default Category;
